module.exports = __webpack_public_path__ + "img/ic_reddot.7025985.png";